// src/App.js
import 'bootstrap/dist/css/bootstrap.min.css';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import EditColumnRestriction from './components/Analytics/ColumnRestrictions/EditColumnRestriction.tsx';
import ReportColumnRestrictions from './components/Analytics/ColumnRestrictions/ReportColumnRestrictions.tsx';
import TreeReportView from './components/Analytics/TreeReportView.tsx';
import ApprovalWrapper from './components/Approval/ApprovalWrapper.tsx';
import ChangePassword from './components/Auth/ChangePassword.tsx';
import ForgetPassword from './components/Auth/ForgetPassword.tsx';
import MsalRedirectHandler from './components/Auth/MsalRedirectHandler.tsx';
import SetPassword from './components/Auth/SetPassword.tsx';
import RolleEditorFull from './components/Filters/RoleEditorFull.tsx';
import UserRequest from './components/Forms/UserRequest/UserRequest.tsx';
import Home from './components/Home/Home.tsx';
import Login from './components/Login/Login.tsx';
import Navbar from './components/Navbar/Navbar';
import PrivateRoute from './components/PrivateRoute';
import RoleGroupsManager from './components/Roles/RoleGroupsManager.tsx';
import RoleGroupWrapper from './components/Roles/RoleGroupWrapper.tsx';
import SettingsManager from './components/Settings/SettingsManager.tsx';
import Sidebar from './components/Sidebar/Sidebar';
import RolesTable from './components/Tables/RolesTable.tsx';
import UserProfile from './components/Users/UserProfile.tsx';
import UserSummary from './components/Users/UserSummary';
import UserWrapper from './components/Users/UserWrapper.tsx';
import { AppProvider } from './context/AppContext.tsx';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider as CustomThemeProvider, useTheme } from './context/ThemeContext';
import { ToastProvider } from './context/ToastContext.tsx';
import { GlobalStyles } from './styles/GlobalStyles';
import { JoyrideProvider } from './UIComponents/JoyrideTour/JoyrideContext.tsx';
import UserDataPreview from './components/Analytics/UserDataPreview.tsx';

const Layout = ({ children }) => {
  return (
    <div style={{ display: 'flex', minHeight: '100vh', overflow: "none" }}>
      <Sidebar />
      <div className='d-flex flex-column' style={{ width: "calc(100vw - 260px)", height: "100vh" }}>
        <Navbar />
        <main className='w-100 d-flex flex-column' style={{
          padding: '0px',
          height: "calc(100vh - 58px)"
        }}>
          {children}
        </main>
      </div>
    </div>
  );
};

const ThemedApp = () => {
  const { themeConfig } = useTheme();


  return (
    <StyledThemeProvider theme={themeConfig}>
      <GlobalStyles />
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgetPassword />} />
          <Route path="/set-password" element={<SetPassword />} />
          <Route
            path="/*"
            element={
              <PrivateRoute>
                <Layout>
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/change-password" element={<ChangePassword />} />
                    <Route path="requests/*" element={<ApprovalWrapper />} />
                    <Route path="requests/create" element={<UserRequest />} />
                    <Route path="/usersummary" element={<UserSummary />} />
                    <Route path="/roles" element={<RolesTable />} />
                    <Route path="/roles/roledetails" element={<RolleEditorFull />} />
                    <Route path="/rolegroups" element={<RoleGroupsManager allRoles={[]} />} />
                    <Route path="/rolegroups/edit/*" element={<RoleGroupWrapper />} />
                    <Route path="/users/*" element={<UserWrapper />} />
                    <Route path="/columnrestrictions" element={<ReportColumnRestrictions />} />
                    <Route path="/columnrestrictions/details*" element={<EditColumnRestriction />} />
                    <Route path="/analytics" element={<TreeReportView />} />
                    <Route path="/datapreview" element={<UserDataPreview />} />
                    <Route path="/settings/*" element={<SettingsManager />} />
                    <Route path="/profile" element={<UserProfile />} />
                    <Route path="/profile/*" element={<UserWrapper />} />
                    {/* Add other protected routes here */}
                  </Routes>
                </Layout>
              </PrivateRoute>
            }
          />
        </Routes>
      </Router>
    </StyledThemeProvider>
  );
};

const App = () => {
  return (
    <JoyrideProvider>
      <CustomThemeProvider>
        <ToastProvider>
          <AuthProvider>
            <AppProvider>
              <MsalRedirectHandler />
              <ThemedApp />
            </AppProvider>
          </AuthProvider>
        </ToastProvider>
      </CustomThemeProvider>
    </JoyrideProvider>
  );
};

export default App;